import cs from 'classnames';
import moment from 'moment';
import { Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { IBooking, IBookingEvent } from '../../../interfaces/booking.interface';
import { extractStatusData, extractStatusDataWithReason } from '../../../utils/events';
import { STATUSES } from '../../../const/booking.constants';
import AcceptedStatus from './Accepted';
// import ArrivedAtPickupStatus from './ArrivedAtPickup';
// import WayToDeliverStatus from './WayToDeliver';
// import ArrivedAtDeliveryStatus from './ArrivedAtDelivery';
// import CompletedStatus from './Completed';
// import CancelledByAdminStatus from './CancelledByAdmin';
// import ReturningStatus from './Returning';
// import CancelledByBusinessStatus from './CancelledByBusiness';
// import CancelledByDeliveryProviderStatus from './CancelledByDeliveryProvider';
// import ReturnedStatus from './Returned';
// import NotDeliveredStatus from './NotDelivered';
// import ProviderNotFoundStatus from './ProviderNotFound';
import { useWorkspaceStore } from '../../../store/workspace.store';
import ArrivedAtPickupStatus from './ArrivedAtPickup';
import WayToDeliverStatus from './WayToDeliver';
import ArrivedAtDeliveryStatus from './ArrivedAtDelivery';
import CompletedStatus from './Completed';

interface Props {
    showDetail?: boolean;
    booking: IBooking;
    bookingEvent: IBookingEvent;
    bookingEvents: IBookingEvent[];
    bookingEventSelected: boolean;
}

const { Text } = Typography;

const StatusUpdate = ({
    // eslint-disable-next-line no-unused-vars
    showDetail = false, booking, bookingEvent, bookingEvents, bookingEventSelected,
}: Props) => {
    const { t } = useTranslation('bookings', { keyPrefix: 'DETAIL' });
    const workspace = useWorkspaceStore((state) => state.data);

    const date = moment(bookingEvent?.createdAt).format('DD MMM HH:mm');

    const includeReason = bookingEvent?.description.includes('by');

    const statusData = includeReason ? extractStatusData(bookingEvent?.description || '') : extractStatusDataWithReason(bookingEvent?.description || '');
    const currentStatus = statusData?.status.split('.')[0];

    const providerName = workspace?.name;

    return (
        !showDetail ? (
            <div className={cs('booking__status', { active: bookingEventSelected })}>
                <Text>
                    <Trans
                        t={t}
                        i18nKey={`STORY_LINE.STATUS.${currentStatus}`}
                        components={{ b: <b className="booking__status--bold" /> }}
                        values={{
                            customerName: booking?.customerName,
                            businessName: booking?.businessName,
                            deliveryProvider: providerName,
                        }}
                    />
                </Text>
                <Text className="booking__status--time">
                    {date}
                </Text>
            </div>
        ) : (
            <>
                {/* {
                    currentStatus === STATUSES.READY_FOR_PICKUP && (
                        <ReadyForPickupStatus
                            type="SUCCESS"
                            booking={booking}
                            bookingEvent={bookingEvent}
                        />
                    )
                } */}
                {
                    currentStatus === STATUSES.ACCEPTED && (
                        <AcceptedStatus
                            type="SUCCESS"
                            booking={booking}
                            bookingEvent={bookingEvent}
                        />
                    )
                }
                {
                    currentStatus === STATUSES.ARRIVED_AT_PICKUP && (
                        <ArrivedAtPickupStatus
                            type="SUCCESS"
                            booking={booking}
                            bookingEvent={bookingEvent}
                            deliveryProvider={statusData.updatedByProvider}
                        />
                    )
                }
                {
                    currentStatus === STATUSES.WAY_TO_DELIVER && (
                        <WayToDeliverStatus
                            type="SUCCESS"
                            booking={booking}
                            bookingEvent={bookingEvent}
                        />
                    )
                }
                {
                    currentStatus === STATUSES.ARRIVED_AT_DELIVERY && (
                        <ArrivedAtDeliveryStatus
                            type="SUCCESS"
                            booking={booking}
                            bookingEvent={bookingEvent}
                        />
                    )
                }
                {
                    currentStatus === STATUSES.COMPLETED && (
                        <CompletedStatus
                            type="SUCCESS"
                            booking={booking}
                            bookingEvent={bookingEvent}
                        />
                    )
                }
                {/*
                {
                    currentStatus === STATUSES.WAY_TO_DELIVER && (
                        <WayToDeliverStatus
                            type="SUCCESS"
                            booking={booking}
                            bookingEvent={bookingEvent}
                            bookingEvents={bookingEvents}
                            deliveryProvider={statusData.updatedByProvider}
                        />
                    )
                }
                {
                    currentStatus === STATUSES.ARRIVED_AT_DELIVERY && (
                        <ArrivedAtDeliveryStatus
                            type="SUCCESS"
                            booking={booking}
                            bookingEvent={bookingEvent}
                            bookingEvents={bookingEvents}
                            deliveryProvider={statusData.updatedByProvider}
                        />
                    )
                }
                {
                    currentStatus === STATUSES.COMPLETED && (
                        <CompletedStatus
                            type="SUCCESS"
                            booking={booking}
                            bookingEvent={bookingEvent}
                            deliveryProvider={statusData.updatedByProvider}
                        />
                    )
                }
                {
                    currentStatus === STATUSES.CANCELLED_BY_ADMIN && (
                        <CancelledByAdminStatus
                            type="FAILED"
                            booking={booking}
                            bookingEvent={bookingEvent}
                            deliveryProvider={statusData.updatedByProvider}
                        />
                    )
                }
                {
                    currentStatus === STATUSES.CANCELLED_BY_BUSINESS && (
                        <CancelledByBusinessStatus
                            type="FAILED"
                            booking={booking}
                            bookingEvent={bookingEvent}
                            deliveryProvider={statusData.updatedByProvider}
                        />
                    )
                }
                {
                    currentStatus === STATUSES.CANCELLED_BY_DELIVERY_PROVIDER && (
                        <CancelledByDeliveryProviderStatus
                            type="FAILED"
                            booking={booking}
                            bookingEvent={bookingEvent}
                            deliveryProvider={statusData.updatedByProvider}
                        />
                    )
                }
                {
                    currentStatus === STATUSES.NOT_DELIVERED && (
                        <NotDeliveredStatus
                            type="FAILED"
                            booking={booking}
                            bookingEvent={bookingEvent}
                            deliveryProvider={statusData.updatedByProvider}
                        />
                    )
                }
                {
                    currentStatus === STATUSES.RETURNING && (
                        <ReturningStatus
                            type="RESOLVING"
                            booking={booking}
                            bookingEvent={bookingEvent}
                            deliveryProvider={statusData.updatedByProvider}
                        />
                    )
                }
                {
                    currentStatus === STATUSES.RETURNED && (
                        <ReturnedStatus
                            booking={booking}
                            bookingEvent={bookingEvent}
                            deliveryProvider={statusData.updatedByProvider}
                        />
                    )
                }
                {
                    currentStatus === STATUSES.PROVIDER_NOT_FOUND && (
                        <ProviderNotFoundStatus
                            type="FAILED"
                            booking={booking}
                            bookingEvent={bookingEvent}
                            deliveryProvider={statusData.updatedByProvider}
                        />
                    )
                } */}
            </>
        )
    );
};

export default StatusUpdate;
